import { service } from '@/ajax/request'
import { ProductList, CreateProductClass, CreateProduct, ChecktProductClass, UpdateNavStatus, UpdateShowStatus, CreateProductAttribute } from '@/types/api/productList'
import { Id } from '@/types/common'
import { AxiosPromise } from 'axios'

// 商品列表
export const productList = (params: ProductList): AxiosPromise => (
  service({
    url: `/pms/product/list`,
    method: 'GET',
    params,
    type: 'form'
  })
)

// 创建商品
export const createProduct = (params: CreateProduct): AxiosPromise => (
  service({
    url: '/pms/product/create',
    method: 'POST',
    params
  })
)

// 更新商品
export const updateProduct = (params: CreateProduct): AxiosPromise => (
  service({
    url: `/pms/product/update/${params.id}`,
    method: 'POST',
    params
  })
)

// 根据商品id获取商品编辑信息
export const updateInfo = (params: { id: number }): AxiosPromise => (
  service({
    url: `/pms/product/updateInfo/${params.id}`,
    method: 'GET',
    params
  })
)

// 添加产品分类
export const createProductClass = (params: CreateProductClass): AxiosPromise => (
  service({
    url: `/pms/productCategory/create`,
    method: 'POST',
    params
  })
)

// 删除商品分类
export const deleteProductClass = (params: Id): AxiosPromise => (
  service({
    url: `/pms/productCategory/delete/${params.id}`,
    method: 'POST'
  })
)

// 分页查询商品分类
export const checktProductClass = (params: ChecktProductClass): AxiosPromise => (
  service({
    url: `/pms/productCategory/list/${params.parentId}`,
    method: 'GET',
    params: {
      pageNum: params.pageNum,
      pageSize: params.pageSize
    }
  })
)

// 修改导航栏显示状态
export const updateNavStatus = (params: UpdateNavStatus): AxiosPromise => (
  service({
    url: `/pms/productCategory/update/navStatus`,
    method: 'POST',
    params
  })
)

// 修改显示状态
export const updateShowStatus = (params: UpdateShowStatus): AxiosPromise => (
  service({
    url: `/pms/productCategory/update/showStatus`,
    method: 'POST',
    params,
    type: 'form'
  })
)

// 修改商品分类
export const updateProductClass = (params: CreateProductClass): AxiosPromise => (
  service({
    url: `/pms/productCategory/update/${params.id}`,
    method: 'POST',
    params
  })
)

// 根据id获取商品分类
export const getProductClassById = (params: Id): AxiosPromise => (
  service({
    url: `/pms/productCategory/${params.id}`,
    method: 'GET',
    params
  })
)

// 获取当Sku信息
export const getProductSku = (params: Id): AxiosPromise => (
  service({
    url: `/pms/productSku/product/${params.id}`,
    method: 'GET',
    params
  })
)


// 添加商品属性（款式）
export const createProductAttribute = (params: CreateProductAttribute): AxiosPromise => (
  service({
    url: `/pms/productAttribute/create`,
    method: 'POST',
    params
  })
)

// 根据ID删除商品属性（款式）
export const deleteProductAttribute = (params: Id): AxiosPromise => (
  service({
    url: `/pms/productAttribute/delete/${params.id}`,
    method: 'POST',
    params,
    type: 'form'
  })
)

// 根据ID删除商品属性（款式）
export const selectProductAttribute = (params: Id): AxiosPromise => (
  service({
    url: `/pms/productAttribute/selectOne`,
    method: 'GET',
    params,
    type: 'form'
  })
)

// 查询商品属性（款式）通过商品id
export const selectProductAttributeByProductId = (params: Id): AxiosPromise => (
  service({
    url: `/pms/productAttribute/selectProductAttributeByProductId/${params.id}`,
    method: 'GET',
    type: 'form'
  })
)

// 修改商品属性（款式）
export const updateProductAttribute = (params: Id): AxiosPromise => (
  service({
    url: `/pms/productAttribute/update/${params.id}`,
    method: 'GET',
    params
  })
)

// 获取所有的商品分类
export const productCategoryAll = (): AxiosPromise => (
  service({
    url: `/pms/productCategory/allList/`,
    method: 'GET',
    type: 'form'
  })
)

// 修改分类的标签
export const productCategoryUpdateTags = (): AxiosPromise => (
  service({
    url: `/pms/productCategory/update/tags`,
    method: 'post',
    type: 'form'
  })
)

// 修改商品分类图标
export const productCategoryUpdateIcon = (params: { id: number, icon: string }): AxiosPromise => (
  service({
    url: `/pms/productCategory/updateIcon/${params.id}`,
    method: 'post',
    type: 'form'
  })
)

// 修改商品上下架
export const updateStatus = (params: { id: number, publishStatus?: number, verifyStatus?: number }): AxiosPromise => (
  service({
    url: `/pms/product/updateStatus/${params.id}`,
    method: 'post',
    params
  })
)

/**
 * 根据id获取子类
 * @param number 
 */
export const sublist = (params: { parentId: number }): AxiosPromise => (
  service({
    url: `/sys/dict/sublist/${params.parentId}`,
    method: 'get',
    type: 'form'
  })
)

/**
 * 获取产品图片二维码url，path:商品的路径 图片保存在对象存储中
 * 
 */
 export const getQRCode = (params: { id: number,path:string }): AxiosPromise => (
  service({
    url: `/pms/product/getQRCode/${params.id}`,
    method: 'get',
    type: 'form',
    params:{
      path:params.path
    }
  })
)
